import React from "react";
import { Table, Pagination } from "antd";
import { ExclamationCircleOutlined } from '@ant-design/icons'
import './index.sass'
import UserInfo from "../../components/UserInfo";
import api from "../../utils/api";
import qs from "../../utils/qs";

export default class OrdersReport extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            dataSource: [],
            page: 1,
            total: 0
        }
    }

    componentDidMount() {
        this.get_orders_exports()
    }

    get_orders_exports = async (page = 1) => {//获取导出订单任务
        this.setState({
            page
        })

        let param = {
            page,
            page_size: 15
        }

        let res = await api('get-orders-exports', param);

        if (res.code === 200) {
            this.setState({
                dataSource: res.data
            })
        }

        //console.log(res)
    }

    downLoad = (arr) => {
        if (arr instanceof Array) {
            for (let i in arr) {
                qs.download(arr[i])
            }
        }
    }

    render() {

        let { dataSource, page, total } = this.state

        const columns = [
            {
                title: '名称',
                dataIndex: 'name',
                key: 'name',
            },
            {
                title: '订单时间范围',
                dataIndex: 'age',
                key: 'age',
            },
            {
                title: '报表生成时间',
                render: (ctx) => {
                    return (
                        <p>
                            {ctx.run_time ? ctx.run_time : '/'}
                        </p>
                    )
                }
            },
            {
                title: '报表状态',
                render(ctx){
                    return(
                        <p>{qs.orderExportStatus(ctx.status)}</p>
                    )
                }
            },
            {
                title: '操作',
                render: (ctx) => {
                    return (

                        ctx.url ? (<div onClick={() => { this.downLoad(ctx.url) }} className='themeColor pointer'>点击下载</div>) : (<p>尚未生成</p>)

                    )

                }
            },
        ];
        return (
            <div className='ordersReport'>
                {/* 头部 */}
                <UserInfo rightBox={<ul className='flex census'>
                    <li>
                        <label>全部商户</label>
                        <p>26</p>
                    </li>
                    <li>
                        <label>全部粉丝</label>
                        <p>26</p>
                    </li>
                </ul>} />


                <div className='prompt flex'>

                    <ExclamationCircleOutlined style={{ color: '#FFC552', fontSize: 14 }} />
                    <p className='prompt_text mgl10'>系统将为您保留近30天内的导出数据，便于您随时导出下载</p>


                </div>


                <div className='record'>
                    <div className='change_fans'>
                        <Table dataSource={dataSource} columns={columns} pagination={false} scroll={
                            {
                                scrollToFirstRowOnChange: false,
                                x: false
                            }
                        } />
                    </div>
                </div>


                <div className='page_style'>
                    <Pagination
                        page_size={15}
                        hideOnSinglePage={true}
                        onChange={(e) => { this.get_orders_exports(e) }}
                        defaultCurrent={1} showSizeChanger={false}
                        current={page}
                        total={total} />
                </div>



            </div>
        )
    }
}